module.exports = __webpack_public_path__ + "static/a.board-9ddd956111820ac5141ab11c5d480572.jpg";